import { Map } from 'immutable';
import moment from 'moment';
import { SYSTEM_SETTINGS, LOOKUPS } from '@iso/containers/constants';

export function clearToken() {
  localStorage.removeItem('idToken');
}

export function clearModules() {
  localStorage.removeItem('modules');
}

export function clearIdentity() {
  localStorage.removeItem('identity');
}

export function clearStores() {
  localStorage.removeItem('stores');
}
export function clearTopic() {
  localStorage.removeItem('topic');
}
export function clearEnv() {
  localStorage.removeItem('env');
}
export function clearMqttToken() {
  localStorage.removeItem('mqttToken');
}
export function clearCustomAuth() {
  localStorage.removeItem('customAuthorizations');
}
export function clearCustomModule() {
  localStorage.removeItem('customModules');
}
export function clearRoles() {
  localStorage.removeItem('roles');
}
export function clearForbidToken() {
  localStorage.removeItem('forbidToken');
}
export function clearMerchantList() {
  localStorage.removeItem('merchantList');
}
export function clearSelectedMerchant() {
  localStorage.removeItem('selectedMerchant');
}
export function clearSelectedMerchantName() {
  localStorage.removeItem('selectedMerchantName');
}
export function clearRequestFormats() {
  localStorage.removeItem('requestFormats');
}
export function clearMqOpts() {
  localStorage.removeItem('mqOpts');
}


export function getMqOpts() {
   try {
    const mqOpts = localStorage.getItem('mqOpts');
    return new Map({ mqOpts });
  } catch (err) {
    clearMqOpts();
    return new Map();
  }
}

export function getToken() {
  try {
    const idToken = localStorage.getItem('idToken');
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function getModules() {
  try {
    const modules = localStorage.getItem('modules');
    return new Map({ modules });
  } catch (err) {
    clearModules();
    return new Map();
  }
}

export function getForbidToken() {
  try {
    const forbidToken = localStorage.getItem('forbidToken');
    return new Map({ forbidToken });
  } catch (err) {
    clearModules();
    return new Map();
  }
}

export function getIdentity() {
  try {
    const identity = localStorage.getItem('identity');
    return new Map({ identity });
  } catch (err) {
    clearModules();
    return new Map();
  }
}

export function getStores() {
  try {
    const stores = localStorage.getItem('stores');
    return new Map({ stores });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getTopic() {
  try {
    const topic = localStorage.getItem('topic');
    return new Map({ topic });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getEnv() {
  try {
    const env = localStorage.getItem('env');
    return new Map({ env });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getMqttToken() {
  try {
    const mqttToken = localStorage.getItem('mqttToken');
    return new Map({ mqttToken });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getCustomAuth() {
  try {
    const customAuthorizations = localStorage.getItem('customAuthorizations');
    return new Map({ customAuthorizations });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getCustomModule() {
  try {
    const customModules = localStorage.getItem('customModules');
    return new Map({ customModules });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getRoles() {
  try {
    const roles = localStorage.getItem('roles');
    return new Map({ roles });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getMerchantList() {
  try {
    const merchantList = localStorage.getItem('merchantList');
    return new Map({ merchantList });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getSelectedMerchant() {
  try {
    const selectedMerchant = localStorage.getItem('selectedMerchant');
    return new Map({ selectedMerchant });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getSelectedMerchantName() {
  try {
    const selectedMerchantName = localStorage.getItem('selectedMerchantName');
    return new Map({ selectedMerchantName });
  } catch (err) {
    clearModules();
    return new Map();
  }
}
export function getRequestFormats() {
  try {
    const requestFormats = localStorage.getItem('requestFormats');
    return new Map({ requestFormats });
  } catch (err) {
    clearModules();
    return new Map();
  }
}

export function arrayEqual(array1, array2) {
  return array1.sort().toString() === array2.sort().toString();
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = number => {
    return number > 1 ? 's' : '';
  };
  const number = num => (num > 9 ? '' + num : '0' + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + ' day' + numberEnding(days);
      } else {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}

export function customLogs(text, object) {
  if (process.env.REACT_APP_ENVIRONMENT.toUpperCase() === 'DEVELOPMENT') {
    if (object && object !== undefined) {
      return console.log(text, object);
    } else {
      return console.log(text);
    }
  } else {
    return null;
  }
}

export const actionPermission = (payload, pageActionArr) => {
  let access = pageActionArr.find(item => item.code === payload && item.is_active === true);
  return access;
};

export const allowAction = (code, pageActionArr) => {
  try {
    let access = pageActionArr.find(item => item.code === code && item.is_active === true);
    return access?.is_active || false;
  } catch {
    return false;
  }
};

export const isInNext3Months = dateToCheck => {
  return moment().subtract(3, 'months').isSameOrBefore(moment(dateToCheck));
};

export const checkDateIfPassed = date => {
  try {
    let isAfter = moment(moment(date).startOf('day')).isSameOrAfter(
      moment(new Date()).startOf('day')
    ); // true

    return isAfter;
  } catch (err) {
    return true;
  }
};

export const filterDuplicateData = currentList => {
  const uniqueIds = [];
  const unique = currentList.filter(element => {
    const isDuplicate = uniqueIds.includes(element.id);

    if (!isDuplicate) {
      uniqueIds.push(element.id);
      return true;
    }
    return false;
  });

  return unique;
};

export const filterDuplicateTransactitonData = (currentList, uniqueField) => {
  const uniqueIds = [];
  const unique = currentList.filter(element => {
    const isDuplicate = uniqueIds.includes(element[uniqueField]);

    if (!isDuplicate) {
      uniqueIds.push(element[uniqueField]);
      return true;
    }
    return false;
  });

  return unique;
};

export const filterDuplicateTransactionDataWithAmount = (currentList, uniqueField) => {
  const uniqueIds = [];
  const unique = currentList.filter(element => {
    const isDuplicate = uniqueIds.some(obj => {
      const objId = obj['id'];
      const objAmount = obj['amount'];

      return objId === element[uniqueField] && objAmount === element['amount'];
    });
    // uniqueIds.includes(element[uniqueField]);

    if (!isDuplicate) {
      uniqueIds.push({
        id: element[uniqueField],
        amount: element['amount']
      });
      return true;
    }
    return false;
  });

  return unique;
};

export const filterDuplicateMerchantData = currentList => {
  const uniqueIds = [];
  const unique = currentList.filter(element => {
    const isDuplicate = uniqueIds.includes(element.merchant_id.toLowerCase());

    if (!isDuplicate) {
      uniqueIds.push(element.merchant_id);
      return true;
    }
    return false;
  });

  return unique;
};

export const findMonitoringItemByCode = (code, arr) => {
  try {
    if (arr && arr.length > 0 && code && code !== '') {
      return arr.some(item => item.toUpperCase() === code.toUpperCase());
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};

export const convertToArrayOfItem = (field, arr) => {
  try {
    let finalArr = [];
    if (arr && arr.length > 0 && field && field !== '') {
      arr.forEach(item => {
        finalArr.push(item[field]);
      });
    }
    return finalArr;
  } catch (err) {
    return [];
  }
};

export const sortModuleByPosition = roleModule => {
  try {
    const sortedModule = roleModule.sort((a, b) => a.position - b.position);
    let finalData = [];
    sortedModule.forEach(module => {
      let currentModuleObj = {
        id: module.id,
        name: module.name,
        code: module.code
      };
      if (module.pages && module.pages.length > 0) {
        let sortedPageData = module.pages.sort((a, b) => a.position - b.position);
        currentModuleObj.pages = sortedPageData;
      }

      finalData.push(currentModuleObj);
    });

    return finalData;
  } catch (err) {
    return roleModule;
  }
};

export const processNotificationDispatch = (notificationData, dispatch) => {
  for (const notificationFilter of notificationData.notification_filter) {
    if (notificationFilter.action && notificationFilter.payload) {
      if (notificationFilter.pagination) {
        dispatch({
          type: notificationFilter.action,
          payload: notificationFilter.payload,
          pagination: notificationFilter.pagination
        });
      } else {
        dispatch({
          type: notificationFilter.action,
          payload: notificationFilter.payload
        });
      }
    }
  }
};

export const deobfuscate = (systemSettings, value) => {
  try {
    const systemSettingsDecryption = systemSettings
      ? systemSettings.find(item => item.group === SYSTEM_SETTINGS.DECRYPTION_CREDENTIALS)
      : null;
    const target =
      systemSettingsDecryption &&
      systemSettingsDecryption.value &&
      systemSettingsDecryption.value.target
        ? systemSettingsDecryption.value.target
        : '';
    const source =
      systemSettingsDecryption &&
      systemSettingsDecryption.value &&
      systemSettingsDecryption.value.source
        ? systemSettingsDecryption.value.source
        : '';

    let finalData = '';
    for (let index = 0; index < value.length; index++) {
      const element = value[index];
      const currentPos = window.atob(target).indexOf(element);
      finalData += window.atob(source)[currentPos];
    }
    return finalData;
  } catch (e) {
    return 'INVALID';
  }
};

export const findIfActive = (moduleStatus, pageStatus) => {
  try {
    if (moduleStatus === LOOKUPS.ACTIVE) {
      if (pageStatus === LOOKUPS.ACTIVE) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export const findSystemSettingsValue = (group, systemSettings) => {
  try {
    const setting = systemSettings.find(setting => setting.group === group);
    return setting.value;
  } catch (e) {
    return {};
  }
};

export const convertArrayToObject = (arr, parameter, value) => {
  try {
    let finalObj = {};
    arr.forEach(item => {
      finalObj[item[parameter]] = item[value];
    });
    return finalObj;
  } catch (e) {
    return {};
  }
};

export const removeEmptyStringValues = obj => {
  try {
    const data = Object.keys(obj).reduce((acc, key) => {
      if (obj[key] !== '') {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
    return data;
  } catch (error) {
    return {};
  }
};

export const parseOrRetrieveGeolocation = geolocation => {
  try {
    const lastAccessGeolocation = geolocation;
    return lastAccessGeolocation
      ? typeof lastAccessGeolocation == 'string'
        ? JSON.parse(lastAccessGeolocation)
        : lastAccessGeolocation
      : {};
  } catch (error) {
    return {};
  }
};

export const formatAmount = value => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const validateEmail = email => {
  try {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  } catch (error) {
    return false;
  }
};

export const disabledDateBasedOnFrequency = (current, config) => {
  try {
    if (config && config.frequency && config.duration) {
      const dynamicDate = moment().add(config.duration, config.frequency.toLowerCase());
      return current && current.valueOf() < dynamicDate.endOf(config.frequency.toLowerCase());
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const getDateBasedOnFrequency = (config, value) => {
  try {
    if (config && config.frequency) {
      return moment(value).endOf(config.frequency).format('YYYY-MM-DD HH:mm:ss');
    }
  } catch (error) {
    return moment(value).endOf('days').format('YYYY-MM-DD HH:mm:ss');
  }
};

export const formatNumber = (value, trimIntegerDecimals = false) => {
  // Handle null/undefined/NaN
  if (value === null || value === undefined) return '0';
  const numberValue = Number(value);
  if (isNaN(numberValue)) return '0';

  // Determine fraction digits based on trim flag and whether the number is an integer
  const isInteger = numberValue % 1 === 0;
  const fractionDigits = trimIntegerDecimals && isInteger ? 0 : 2;

  return numberValue.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });
};
